import { withRouter } from 'react-router-dom';
import CircleTimeline from './CircleTimeline';

export default withRouter(CircleTimeline);
